import { Input } from '@bpinternal/ui-kit-next'
import { MAX_BOTNAME_LENGTH } from '~/routes/workspaces/$workspaceId/bots/$botId/overview'

type RenamePromptProps = {
  value?: string
  setValue: (value: string) => void
  setValid: (valid: boolean) => void
  currentBotName: string
}

export const RenamePrompt = ({ value, setValue, setValid, currentBotName }: RenamePromptProps) => {
  const handleChange = (newValue: string) => {
    setValue(newValue)
    const trimmedValue = newValue.trim()
    const trimmedCurrentName = currentBotName.trim()

    const hasValidContent = trimmedValue.length > 0
    const hasChanged = trimmedValue !== trimmedCurrentName

    setValid(hasChanged && hasValidContent)
  }

  return (
    <div className="space-y-2">
      <Input
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        placeholder="Enter bot name"
        defaultValue={currentBotName}
        autoFocus
        maxLength={MAX_BOTNAME_LENGTH}
      />
      <div className="text-xs text-gray-500">
        {value?.length ?? 0}/{MAX_BOTNAME_LENGTH} characters
      </div>
    </div>
  )
}
